// Centralised brand constants for GrowFlow landing.
export const PHONE = "+91 9975247407";
export const PHONE_E164 = "919975247407";
export const PHONE_TEL = "+919975247407";
export const WHATSAPP_URL = `https://wa.me/${PHONE_E164}?text=${encodeURIComponent(
  "Hi GrowFlow, I want to get more patients/customers from Google. Please share details."
)}`;
export const TEL_URL = `tel:${PHONE_TEL}`;
